import { SureprepAPI } from 'jobs/API'
import { Id } from 'types/definitions'

export default class SureprepStore {
  constructor(private api: SureprepAPI) {}

  async downloadBinder(id: Id) {
    await this.api.downloadPBFXFile(Id.assert(id))
  }
}
